export const DUE_DATE_EXTENSION_LIMIT = 3;

export const AUDIT_COMMENCEMENT_DOCUMENTS = 'AUDIT COMMENCEMENT DOCUMENTS';
